export default (value) => {
    return (value instanceof Number || typeof value === 'number') && !isNaN(value);
};
